export default __webpack_public_path__ + "static/media/icon_check.a37b7ce5.svg";